module.exports = __webpack_public_path__ + "img/icon-youtube.dfc7e050.svg";